import { CircleLoader, Space } from '@procurify/ui'
import { useTheme } from 'styled-components'

/**
 * Presentational Feature Set subcomponent — a centred section loader. DS
 * `CircleLoader` defaults to white, so it takes the secondary text colour to
 * stay visible on a card.
 */
export const ReportAccessSectionLoader = () => {
  const theme = useTheme()

  return (
    <Space direction='horizontal' justify='center'>
      <CircleLoader color={theme.colors.text.secondary} />
    </Space>
  )
}

ReportAccessSectionLoader.displayName = 'ReportAccessSectionLoader'
